import type DestinationsCard from "@travily/types/models/DestinationsCard";
import type { DestinationsCardPhotoTrait } from "@travily/types/models/DestinationsCard";
import { CardGrid } from "@ui/components/CardGrid";
import { EmptyState } from "@ui/components/EmptyState";
import { Illustration } from "@ui/components/Illustration";
import { DestinationCard } from "@/components/DestinationCard/DestinationCard";

type FavoriteDestination = DestinationsCard & DestinationsCardPhotoTrait;

export interface DestinationFavoritesProps {
  destinations: FavoriteDestination[];
  empty: { description: string; title: string };
  getFavorited?: (type: string, id: string | number) => boolean;
  onFavoriteToggle?: (favorableType: string, favorableId: string | number) => void;
}

export function DestinationFavorites({
  destinations,
  empty,
  getFavorited,
  onFavoriteToggle,
}: DestinationFavoritesProps) {
  if (destinations.length === 0) {
    return (
      <EmptyState description={empty.description} illustration={<Illustration name="trips" />} title={empty.title} />
    );
  }

  return (
    <CardGrid>
      {destinations.map((destination) => (
        <DestinationCard
          destination={destination}
          favorited={getFavorited ? getFavorited("Destination", destination.id) : true}
          key={destination.id}
          onFavoriteToggle={onFavoriteToggle ? () => onFavoriteToggle("Destination", destination.id) : undefined}
        />
      ))}
    </CardGrid>
  );
}
